import { isValidAlphanumericText, isValidSearchDate } from './Search';

export const isValidRegistrationNumber = isValidAlphanumericText;
export const isValidLicenceType = isValidAlphanumericText;
export const isValidStatus = isValidAlphanumericText;
export const isValidSupervisor = isValidAlphanumericText;
export const isValidStartDate = isValidSearchDate;
export const isValidEndDate = isValidSearchDate;
